module.exports = "https://cdn-challenge.mathletics.com/app/107/assets/images/51e7eafb5d16ab9cce26446084ae8ba7.svg";